export class UserKindConstant {
  static consumerKindCd: string = "U00";
  static memberKindCd: string = "U10";
}